import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { i18nReducer } from 'react-redux-i18n';

import authReducer from './authReducer';
import messageReducer from './messageReducer';
import moduleReducer from './moduleReducer';
import tableDataReducer from './tableDataReducer';
import appReducer from './appReducer';
import LotReducer from './LotReducer';
import programReducer from './programReducer';
import companyReducer from './../company';
import accountReducer from './../account';
import workflowReducer from './../workflow';
import invoiceReducer from './../invoice';

const rootReducer = combineReducers({
  auth: authReducer,
  form: formReducer,
  messageReducer,
  i18n: i18nReducer,
  moduleReducer,
  tableDataReducer,
  appReducer,
  lot: LotReducer,
  program: programReducer,
  companyReducer,
  accountReducer,
  workflowReducer,
  invoiceReducer,
});

export default rootReducer;




// WEBPACK FOOTER //
// ./src/redux/reducers/index.js